import { render, staticRenderFns } from "./DealerListTickets.vue?vue&type=template&id=6aece214&"
import script from "./DealerListTickets.vue?vue&type=script&lang=js&"
export * from "./DealerListTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports